'use client';
import useStoreUtmTags from '@/utils/hooks/storeUtmTags';

export default function UTMWrapper({ children }: { children: React.ReactNode }) {
  useStoreUtmTags();

  return <>{children}</>;
}
// This component is used to store UTM tags in local storage
// and make them available throughout the application.
// It uses the `useStoreUtmTags` hook to handle the storage logic.
// The `children` prop is used to render the child components